import React from "react";
import { Button } from "react-bootstrap";
import Image from '../../assets/images/banner.png'


function Banner() {

    return (
        <section className="banner-section main-padding">
            <div className="container-fluid p-0">
                <div className="row">
                    <div className="col-md-6">
                        <div className="content-section">
                            <h3>NFT MARKETPLACE</h3>
                            <h1>The best place to analyze, track and discover NFTs</h1>
                            <h4>On the world’s first & largest NFT marketplace</h4>
                            <div className="d-flex button-group">
                                <Button variant="primary">EXPLORE</Button>
                                <Button variant="light">CREATE</Button>
                            </div>
                            <div className="link">
                                <a href="#">
                                    <h6>Get Featured On The Homepage</h6>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="image">
                            <img src={Image} alt="Banner" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Banner;